import "./index.esm.css"
import { defineComponent, ref, onMounted, watch, computed, openBlock, createElementBlock, createElementVNode, normalizeStyle, renderSlot } from 'vue';
import ResizeObserver from 'resize-observer-polyfill';

var script = defineComponent({
    name: 'expander',
    props: {
        expand: {
            default: true
        },
        manner: {
            default: 'vertical fade'
        },
        transition: {
            default: 'all 0.3s ease-in-out'
        },
        playIn: {
            default: false,
        }
    },
    setup(props) {
        const childWidth = ref(0);
        const childHeight = ref(0);
        const initialized = ref(false);
        const thiselement = ref(document.createElement('div'));
        onMounted(() => {
            const elem = thiselement.value.querySelector("#inner");
            const child = elem.children[0];
            if (!child) {
                return;
            }
            child.style.whiteSpace = 'nowrap';
            const ro = new ResizeObserver(children => {
                for (let child of children) {
                    const rect = child.contentRect;
                    childHeight.value = rect.height + rect.top;
                    childWidth.value = rect.width + rect.left;
                }
            });
            ro.observe(child);
            if (props.playIn) {
                initialized.value = true;
            }
        });
        watch(() => props.expand, () => {
            initialized.value = true;
        });
        const width = computed(() => {
            if (props.manner.includes('horizontal')) {
                if (!props.expand) {
                    return 0 + 'px';
                }
                else {
                    return childWidth.value + 'px';
                }
            }
            else {
                return '100%';
            }
        });
        const height = computed(() => {
            if (props.manner.includes('vertical')) {
                if (!props.expand) {
                    return 0 + 'px';
                }
                else {
                    return childHeight.value + 'px';
                }
            }
            else {
                return '100%';
            }
        });
        const opacity = computed(() => {
            if ((!props.expand)
                && props.manner.includes('fade')) {
                return 0;
            }
            else {
                return 1;
            }
        });
        return {
            thiselement,
            width,
            height,
            opacity,
            initialized
        };
    }
});

const _hoisted_1 = {
  class: "_wrapper",
  style: {"width":"100%","overflow":"hidden"},
  ref: "thiselement"
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", {
      class: "expander",
      style: normalizeStyle({
      overflow: 'hidden',
      transition:_ctx.initialized?_ctx.transition:'',
      width: _ctx.width, 
      height: _ctx.height,
      opacity: _ctx.opacity,
    })
    }, [
      createElementVNode("div", {
        style: normalizeStyle({
        width:_ctx.manner.includes('vertical')? '100%' : 'fit-content',
        height:_ctx.manner.includes('horizontal')? '100%' : 'fit-content',
      }),
        id: "inner"
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 4 /* STYLE */)
    ], 4 /* STYLE */)
  ], 512 /* NEED_PATCH */))
}

script.render = render;
script.__file = "src/Component.vue";

const components = { Component: script };
const plugin = {
    install(Vue) {
        for (const prop in components) {
            if (components.hasOwnProperty(prop)) {
                //@ts-ignore
                const component = components[prop];
                Vue.component(component.name, component);
            }
        }
    }
};

export { script as Component, plugin as default };
